import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";

export async function fetchJobPositionsList() {
  const response = await getAPIResponse("/v1/jobPosition-list?offset=0&limit=5000", null, "GET");
  return response?.records || [];
}
